import React, { useState, useEffect } from 'react'
import { FaUndo } from 'react-icons/fa'
import { FiSearch } from 'react-icons/fi'
import { AiOutlineFileExcel } from 'react-icons/ai'
import { IoExitOutline } from 'react-icons/io5'
import { RiSave2Fill } from 'react-icons/ri'
import axios from 'axios'
import { toast } from 'react-toastify'
import { ToastContainer, Flip } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { API_HOST } from '../../api_utils'
import { useNavigate } from 'react-router-dom'


function sumFirstIndex(arr, nameToBeRendered) {
  let sum = 0;
  for (let i = 0; i < arr.length; i++) {
    sum += arr[i][`${nameToBeRendered}`];
  }
  return sum;
}

// function to handle increments in date based on payment frequency of the loan product:
function moveDate(date, number, unit) {
  const d = new Date(date);
  switch (unit) {
    case 'days':
      d.setDate(d.getDate() + number);
      break;
    case 'weeks':
      d.setDate(d.getDate() + (number * 7));
      break;
    case 'months':
      d.setMonth(d.getMonth() + number);
      break;
    case 'years':
      d.setFullYear(d.getFullYear() + number);
      break;
    default:
      break;
  }
  return d;
}

function ProfitReport(props) {
  const { userDataFromStorage, coloredTheme } = props;
  const [tabCount, setTabCount] = useState(0)
  const [loading, setLoading] = useState(false)
  const [userList, setUserList] = useState([])
  const [productList, setProductList] = useState([])
  const [customerList, setCustomerList] = useState([])
  const [loanHeaderList, setLoanHeaderList] = useState([])
  const [claimList, setClaimList] = useState([])
  const [profitByAgentRef, setProfitByAgentRef] = useState([])
  const [profitByManagerRef, setProfitByManagerRef] = useState([])
  const [profitByLoanProductRef, setProfitByLoanProductRef] = useState([])

  let navigate = useNavigate()

  // get user's list:
  const getUsersList = async () => {
    setLoading(true)

    const config = {
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${userDataFromStorage.token}`
      }
    }
    const { data } = await axios.get(`${API_HOST}/api/users/`, config);

    if (data) {
      if (data.message) {
        setLoading(false)
      } else {
        setLoading(false)
        setUserList(data)
      }
    } else {
      setLoading(false)
    }

  }

  const getLoanProductList = async () => {
    setLoading(true)
    const config = {
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${userDataFromStorage.token}`
      }
    }
    const { data } = await axios.get(`${API_HOST}/api/loanproducts/get_loan_products`, config);
    if (data) {
      if (data.message) {
        setLoading(false)
      } else {
        setLoading(false)
        setProductList(data)
      }
    } else {
      setLoading(false)
    }
  }

  const getLoanHeaderList = async () => {
    setLoading(true)
    const config = {
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${userDataFromStorage.token}`
      }
    }
    const { data } = await axios.get(`${API_HOST}/api/loan_header/`, config);
    if (data) {
      if (data.message) {
        setLoading(false)
      } else {
        setLoading(false)
        setLoanHeaderList(data)
      }
    } else {
      setLoading(false)
    }
  }

  const getCustomerList = async () => {
    setLoading(true)
    const config = {
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${userDataFromStorage.token}`
      }
    }
    const { data } = await axios.get(`${API_HOST}/api/customer/get_all_customer`, config);
    if (data) {
      if (data.message) {
        setLoading(false)
      } else {
        setLoading(false)
        setCustomerList(data)
      }
    } else {
      setLoading(false)
    }
  }

  const getClaimList = async () => {
    setLoading(true)
    const config = {
      headers: {
        "Content-Type": "application/json",
        'Authorization': `Bearer ${userDataFromStorage.token}`
      }
    }
    const { data } = await axios.get(`${API_HOST}/api/claim/`, config);
    if (data) {
      if (data.message) {
        setLoading(false)
      } else {
        setLoading(false)
        setClaimList(data)
      }
    } else {
      setLoading(false)
    }
  }

  useEffect(() => {
    getUsersList()
    getLoanProductList()
    getLoanHeaderList()
    getCustomerList()
    getClaimList()
  }, [])

  useEffect(() => {
    const el = document.getElementById('tab0')
    const el1 = document.getElementById('tab1')
    const el2 = document.getElementById('tab2')

    if (tabCount === 0) {
      el.style.backgroundColor = '#cffafe'
      el.style.border = '1px solid gray'
      el1.style.backgroundColor = 'transparent'
      el2.style.backgroundColor = 'transparent'
      el1.style.border = 'none'
      el2.style.border = 'none'

    } else if (tabCount === 1) {
      el.style.backgroundColor = 'transparent'
      el1.style.backgroundColor = '#cffafe'
      el1.style.border = '1px solid gray'
      el2.style.border = 'none'
      el.style.border = 'none'
      el2.style.backgroundColor = 'transparent'

    } else {
      el.style.backgroundColor = 'transparent'
      el1.style.backgroundColor = 'transparent'
      el2.style.backgroundColor = '#cffafe'
      el2.style.border = '1px solid gray'
      el1.style.border = 'none'
      el.style.border = 'none'

    }
  }, [tabCount])


  useEffect(() => {
    let profitByAgentData = []
    let profitByManagerData = []
    let profitByLoanProduct = []
    let startDate = moveDate(new Date(), -6, 'months')
    let endDate = new Date()
    if (userList.length && claimList.length && customerList.length && loanHeaderList.length && productList.length) {
      userList.map((x) => {

        // user->customer(reference)
        const customerIdList = customerList
          .filter((customer) => customer.agent === x._id)

        // claim->user->relation:
        const claimRef = claimList.filter((i) => i.claimer_ref === x._id);


        let claimAmountSum = 0;

        if (claimRef.length > 0) {
          console.log("claimRef", claimRef);

          claimRef.forEach((j) => {
            let claimDate = new Date(j.claim_date)
            console.log("claimDate", claimDate);
            console.log("startDate", startDate);
            console.log("endDate", endDate);
            console.log("j", j);
            if (claimDate >= startDate && claimDate <= endDate) {
              console.log('hererererer111')

              return claimAmountSum = claimAmountSum + Number(j.amount)
            }
          })

        }

        console.log('claimAmountSum1', claimAmountSum)


        if (claimRef.length > 0) {
          claimAmountSum = claimRef.reduce((total, j) => {
            let claimDate = new Date(j.claim_date);
            if (claimDate >= startDate && claimDate <= endDate) {
              return total + Number(j.amount);
            } else {
              return total;
            }
          }, 0);
        }
        console.log("claimAmountSum2", claimAmountSum);//will be used as expense claim


        console.log("customerIdList", customerIdList);
        console.log("x", x);

        if (customerIdList.length) {

          let agentName = x.full_name;
          let managerRef = userList.find((k) => k._id === x.manager)

          console.log("customerIdList", customerIdList);
          console.log('loanHeaderList', loanHeaderList)

          // user->customer->loanHeader(reference)
          customerIdList.map((d) => {
            const loanHeaderCheck = loanHeaderList.filter((b) => b.customer_ref === d._id);

            if (loanHeaderCheck.length) {

              loanHeaderCheck.map((e) => {
                let loanProductCheck = productList.filter((f) => f._id === e.loan_product_ref)
                console.log("loanProductCheck", loanProductCheck);
                console.log('eeee', e)

                if (e.loan_status === 'closed' || e.loan_defaulted === true && e.last_transaction_date >= startDate && e.last_transaction_date <= endDate) {
                  let stampCommissionSum = sumFirstIndex(loanProductCheck, 'stamp_commission')
                  let totalCashOut = sumFirstIndex(loanHeaderCheck, 'amount_dispersed');
                  console.log("total", totalCashOut);
                  let totalCashIn = sumFirstIndex(loanHeaderCheck, 'amount_collected')
                  console.log("total1", totalCashIn);
                  let totalProfit = sumFirstIndex(loanHeaderCheck, 'profit') - claimAmountSum;
                  let dispersedAmountSum = sumFirstIndex(loanHeaderCheck, 'amount_dispersed')
                  let profitOnCashOut = totalProfit - ((claimAmountSum * 100) / dispersedAmountSum)

                  let profitDataForAgent = {
                    manager: managerRef.full_name,
                    agent: agentName,
                    totalCashOut,
                    totalCashIn,
                    totalProfit,
                    expense_claims: claimAmountSum,
                    profitOnCashOut,
                    agentCommission: stampCommissionSum
                  }

                  return profitByAgentData.push(profitDataForAgent)

                }
              })
            }

          }
          )
        }
      })
    }

  

    console.log('profitByAgentData', profitByAgentData)
    setProfitByAgentRef(profitByAgentData)

  }, [userList, claimList, customerList, loanHeaderList, productList])


  return (
    <div className={userDataFromStorage.user_role === 'admin' ? 'xl:px-[10rem] lg:px-[6rem] md:px-[3.5rem] px-[1rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[15%]  xl:mt-[9%] mt-[20%] bg-blue-50  overflow-hidden' : 'xl:px-[10rem] lg:px-[6rem] md:px-[3.5rem] px-[1rem] py-[2rem] font-Roboto md:mt-[10%] lg:mt-[10%]  xl:mt-[5%] mt-[20%] bg-blue-50 overflow-hidden'}>
      <p className='text-gray-800 text-[1.8rem] tracking-wider'>Profitability Reports</p>
      <div className='bg-white  mt-[2%]'>
        <p style={{ backgroundColor: coloredTheme }} className=' text-white px-[0.5rem] py-[1rem] '>Search Parameters</p>
        {
          tabCount === 0 ? <div className='px-[0.5rem] mt-2'>
            <div className='md:flex justify-start items-center mt-6'>
              <p className='w-[25rem]'>Manager Last Name</p>
              <input type="text" className='outline-none border border-gray-400 rounded p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0' />
            </div>
            <div className='md:flex justify-start items-center mt-6'>
              <p className='w-[25rem]'>Agent Last Name </p>
              <input type="text" className='outline-none border border-gray-400 rounded p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0' />
            </div>
            <div className='md:flex justify-start items-center mt-6'>
              <p className='w-[25rem]'>Loan Closed After</p>
              <input type="date" className='outline-none border border-gray-400 rounded p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0' />
            </div>
            <div className='md:flex justify-start items-center mt-6'>
              <p className='w-[25rem]'>Loan Closed Before</p>
              <input type="date" className='outline-none border border-gray-400 rounded p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0' />
            </div>
          </div> : tabCount === 1 ?
            <div className='px-[0.5rem] mt-2'>
              <div className='md:flex justify-start items-center mt-6'>
                <p className='w-[25rem]'>Manager Last Name</p>
                <input type="text" className='outline-none border border-gray-400 rounded p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0' />
              </div>
              <div className='md:flex justify-start items-center mt-6'>
                <p className='w-[25rem]'>Loan Closed After</p>
                <input type="date" className='outline-none border border-gray-400 rounded p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0' />
              </div>
              <div className='md:flex justify-start items-center mt-6'>
                <p className='w-[25rem]'>Loan Closed Before</p>
                <input type="date" className='outline-none border border-gray-400 rounded p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0' />
              </div>
            </div> : <div className='px-[0.5rem] mt-2'>
              <div className='md:flex justify-start items-center '>
                <p className='w-[25rem]'>Loan Closed After</p>
                <input type="date" className='outline-none border border-gray-400 rounded p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0' />
              </div>
              <div className='md:flex justify-start items-center mt-6'>
                <p className='w-[25rem]'>Loan Closed Before</p>
                <input type="date" className='outline-none border border-gray-400 rounded p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0' />
              </div>

              <div className='md:flex justify-start items-center mt-6'>
                <p className='w-[25rem]'>Payment Frequency</p>
                <div className='flex items-center '>
                  <input type={'radio'} id="Daily" />
                  <label className='ml-1 mr-6' htmlFor='Daily'>Daily</label>
                  <input type={'radio'} id="Weekly" />
                  <label className='ml-1 mr-6 ' htmlFor='Weekly'>Weekly</label>
                  <input type={'radio'} id="Monthly" />
                  <label className='ml-1' htmlFor='Monthly'>Monthly</label>
                </div>
              </div>
              <div className='md:flex justify-start items-center mt-6'>
                <p className='w-[25rem]'>Loan Amount Greater Than</p>
                <input type="text" className='outline-none border border-gray-400 rounded p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0' />
              </div>
              <div className='md:flex justify-start items-center mt-6'>
                <p className='w-[25rem]'>Loan Amount Less Than</p>
                <input type="text" className='outline-none border border-gray-400 rounded p-[0.3rem] md:flex-grow w-[100%] md:w-fit mt-2 md:mt-0' />
              </div>

            </div>
        }

        <div className='flex justify-start items-center space-x-4 p-[1rem]'>
          <button style={{ backgroundColor: coloredTheme }} className='flex justify-center items-center  rounded space-x-2 px-[1rem] py-[0.5rem] mt-6 text-white'>
            <FiSearch />
            <p>Search</p>
          </button>
          <button style={{ backgroundColor: coloredTheme }} className='flex justify-center items-center  rounded space-x-2 px-[1rem] py-[0.5rem] mt-6 text-white'>
            <FaUndo />
            <p>Reset</p>
          </button>
        </div>
      </div>

      <div className='mt-8'>
        <p style={{ backgroundColor: coloredTheme }} className=' py-[1rem] px-[0.5rem] text-white'>Reports</p>
        <div className='p-[1rem] bg-white'>
          <div className=' overflow-scroll w-[100%]'>
            <div className='md:w-[100%] w-[150%] flex justify-between items-center'>
              <button id="tab0" onClick={() => setTabCount(0)} className=' px-[1rem] py-[0.5rem] bg-white md:w-1/3 border w-[20%]'>By Agent</button>
              <button id="tab1" onClick={() => setTabCount(1)} className=' px-[1rem] py-[0.5rem] md:w-1/3 w-[30%]'>By Manager</button>
              <button id="tab2" onClick={() => setTabCount(2)} className=' px-[1rem] py-[0.5rem] w-[40%] md:w-1/3'>By Loan Product</button>

            </div>
          </div>
          <p style={{ backgroundColor: coloredTheme }} className=' py-[1rem] px-[0.5rem] text-white'>Total Profit Reported is MYR 0 with Profit on Cash Out of</p>

          <div className='mt-4 overflow-scroll'>
            <table className='md:w-[100%] w-[250%]'>
              <thead style={{ backgroundColor: coloredTheme }} className='border border-gray-700  text-white tracking-wider'>
                <tr>
                  <th className='text-center  px-[0.2rem] border-b border-r   border-gray-700 ' >Manager</th>
                  <th className='text-center  px-[0.2rem] border-b border-r   border-gray-700 ' >Agent</th>
                  <th className='text-center  px-[0.2rem] border-b border-r   border-gray-700 ' >Total Cash Out</th>
                  <th className='text-center  px-[0.2rem] border-b border-r   border-gray-700 '>  Total Cash In</th>
                  <th className='text-center  px-[0.2rem] border-b border-r   border-gray-700 ' >Total Agent Stamp</th>
                  <th className='text-center  px-[0.2rem] border-b border-r   border-gray-700 ' >Expense Claims</th>
                  <th className='text-center  px-[0.2rem] border-b border-r   border-gray-700 ' >Total Profit</th>
                  <th className='text-center  px-[0.2rem] border-b border-r   border-gray-700 ' >Profit on Cash Out</th>
                </tr>
              </thead>
              <tbody>
                {
                  profitByAgentRef.length ? profitByAgentRef.map((x, index) => <tr className={index % 2 === 0 ? 'bg-white border border-gray-700 ' : 'border border-gray-700 bg-sky-100'} key={index} >
                    <td className='text-center border-r border-gray-700  px-[0.2rem] py-[0.3rem]'>{x.manager}</td>
                    <td className='text-center border-r border-gray-700  px-[0.2rem] py-[0.3rem]'>{x.agent}</td>
                    <td className='text-center border-r border-gray-700  px-[0.2rem] py-[0.3rem]'>MYR {x.totalCashOut}</td>
                    <td className='text-center border-r border-gray-700  px-[0.2rem] py-[0.3rem]'>MYR {x.totalCashIn}</td>
                    <td className='text-center border-r border-gray-700  px-[0.2rem] py-[0.3rem]'>MYR {x.agentCommission}</td>
                    <td className='text-center border-r border-gray-700  px-[0.2rem] py-[0.3rem]'>MYR {x.expense_claims}</td>
                    <td className='text-center border-r border-gray-700  px-[0.2rem] py-[0.3rem]'>MYR {x.totalProfit}</td>
                    <td className='text-center border-r border-gray-700  px-[0.2rem] py-[0.3rem]'>MYR {x.profitOnCashOut}</td>
                  </tr>) : <tr className='flex justify-center items-center'>
                  All Loan Status are Active Currently
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>

        <div className='flex justify-start items-center space-x-4 mt-6'>
          <button onClick={() => navigate('/reports/profit_def')} style={{ backgroundColor: coloredTheme }} className='flex justify-center items-center  rounded space-x-2 px-[1rem] py-[0.5rem] mt-6 text-white '>
            <RiSave2Fill />
            <p>Profit Definitions</p>
          </button>
          <button style={{ backgroundColor: coloredTheme }} className='flex justify-center items-center  rounded space-x-2 px-[1rem] py-[0.5rem] mt-6 text-white '>
            <IoExitOutline />
            <p>Exit</p>
          </button>
        </div>
      </div>


      <ToastContainer
        newestOnTop={false}
        rtl={false}
        transition={Flip}
        position="top-right"
        autoClose={2000}
        theme="dark"
        hideProgressBar={false}
        closeOnClick={true}
        pauseOnHover={false}
        draggable={true}
        progress={undefined}
        className="text-center"
      />

    </div>
  )
}

export default ProfitReport